<script>
    import SortableTable from '../SortableTable.svelte';
    import {tables} from '../../lib/tables';
    import {forms} from '../../lib/forms';
    import {addFormModal} from '../../Forms/ModalFormManager.svelte';

    import positiveControlModel from '../../Models/positiveControlModel';

    export let assessment_model;
    let assessment = assessment_model.store;

    let modal;

    let collapsed = true;

    let suggested_services = [];

    let positive_controls = positiveControlModel.getPositiveControlList();

    async function get_recommendations(assessment) {
        let promises = [];
        for (let category of assessment.assessment_type_data.categories) {
            for (let subcategory of category.subcategories) {
                for (let question of subcategory.controls) {
                    if (question.tag_mapping) {
                        for (let [tag_id, mapping] of Object.entries(question.tag_mapping)) {
                            if (assessment_model.getTag(question.id, tag_id).value == 1){
                                for (let map of mapping) {
                                    if (map.startsWith("positiveControl")) {
                                        promises.push(positiveControlModel.getPositiveControl(map))
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        let settled_promises = await Promise.allSettled(promises);
        let results = [];
        for (let p of settled_promises) {
            if (p.status == "fulfilled") {
                results.push(p.value);
            }
        }

        suggested_services = results;
    }

    function addPositiveControl() {
        addFormModal({
            fields: forms['positiveControl']
        }).then((formData) => {
            assessment_model.addPositiveControl(formData)
        })
    }

    function updatePositiveControl(recommendation) {
        addFormModal({
            fields: forms['positiveControl'],
            data: recommendation
        }).then( formData => {
            assessment_model.updatePositiveControl(formData)
        })
    }

    function deletePositiveControl(recommendation) {
        assessment_model.deletePositiveControl(recommendation);
    }

    function doAddFromTemplate(service_recommendation) {
        service_recommendation.template_id = service_recommendation._id,

        service_recommendation._id = undefined;
        service_recommendation._rev = undefined;
        assessment_model.addPositiveControl(service_recommendation);
    }

    function addRecommendationFromTemplate() {
        return new Promise((resolve, reject) => {
            modal = {
                cancelAction: reject,
                saveAction: resolve
            }
        }).then((recommendation_id) => {
            positiveControlModel.getPositiveControl(recommendation_id).then(doAddFromTemplate)
        }).catch(() => {
            null
        }).finally(() => {
            modal = undefined;
        })
    }

    $: get_recommendations($assessment);
</script>
<h2 class="title is-2">Report</h2>
<SortableTable sortFields={tables['positiveControls']} tableData={$assessment.positive_controls} tableClass="NISTTable">
    <div slot="filterActions">
        {#if $assessment.positive_controls.length < 6}
            <button class="button is-success" on:click={addPositiveControl}>Add Positive Control</button>
        {/if}
    </div>
    <div slot="rowActions" let:row={recommendation}>
        <div class="buttons is-centered">
            <button class="button is-danger" on:click={() => deletePositiveControl(recommendation)}>Delete</button>
            <button class="button is-link" on:click={() => updatePositiveControl(recommendation)}>Edit</button>
        </div>
    </div>
    <div slot="footerActions">
        <div class="buttons is-right">
            {#if $assessment.positive_controls.length < 6}
                <button class="button is-primary" on:click={addRecommendationFromTemplate}>Add From Template</button>
            {/if}
        </div>
    </div>
</SortableTable>

{#if $assessment.positive_controls.length < 6 && suggested_services.length}
<h3 class="title is-4 pointer" on:click={() => collapsed = !collapsed}>{collapsed ? "[+]" : "[-]"} Mapped Services</h3>
    {#if !collapsed}
        <SortableTable sortFields={tables['positiveControls']} tableData={suggested_services} tableClass="NISTTable">
            <div slot="rowActions" let:row={service}>
                <button class="button is-link" on:click={() => doAddFromTemplate(service)}>Add To Report</button>
            </div>
        </SortableTable>
    {/if}
{/if}

{#if modal}
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card is-fullwidth">
            <header class="modal-card-head">
            <p class="modal-card-title">Create from Template</p>
                <button class="delete" aria-label="close" on:click={modal.cancelAction}></button>
            </header>
            <section class="modal-card-body">
                <SortableTable sortFields={tables["positiveControls"]} tableData={$positive_controls} tableClass="NISTTable">
                    <div slot="rowActions" let:row={recommendation}>
                        <div class="button is-success" on:click={() => modal.saveAction(recommendation._id)}>Select Control</div>
                    </div>
                </SortableTable>
            </section>
            <footer class="modal-card-foot has-text-right">
                <button class="button is-pulled-right" on:click={modal.cancelAction}>Close</button>
            </footer>
        </div>
    </div>
{/if}